import React from "react";
import {
  FaLinkedinIn,
  FaGithubSquare,
  FaWhatsapp,
  FaInstagram,
} from "react-icons/fa";


const Footer = () => {
  
  const pageLoading = (e, data) => {
    console.log(data);
    if (data === "LI") {
      window.open(
        "https://www.linkedin.com/in/deepesh-kumar-49a192162/",
        "_blank"
      );
    }
    if (data === "WS") {
      window.open(
       "https://wa.me/918210789459",
        "_blank"
      );
    }
    if (data === "IN") {
      window.open(
        "https://www.instagram.com/deepesh6994/",
        "_blank"
      );
    }
    if (data === "GIT") {
      window.open(
        "https://github.com/TECH992",
        "_blank"
      );
    }
  };
  return (
    <div className=" text-gray-300 flex justify-center   ">
      <div className="flex justify-between w-[70%] md:w-[35%] md:my-6">
        <FaLinkedinIn
          size={30}
          className="text-[#1869b5]  hover:scale-150 duration-300 cursor-pointer "
          onClick={(e) => pageLoading(e, "LI")}
        />
        <FaWhatsapp
          size={30}
          className="text-[#3DBE29]  hover:scale-150 duration-300 cursor-pointer "
          onClick={(e) => pageLoading(e, "WS")}
        />
        <FaInstagram
          size={30}
          className="text-[#B4161B]  hover:scale-150 duration-300 cursor-pointer"
          onClick={(e) => pageLoading(e, "IN")}
        />
        <FaGithubSquare
          size={30}
          className="text-[#00D84A]   hover:scale-150 duration-300  cursor-pointer"
          onClick={(e) => pageLoading(e, "GIT")}
        />
      </div>
    </div>
  );
};

export default Footer;
